export default __webpack_public_path__ + "static/media/63_photo.61734518.jpg";